const DAY = 86_400_000;

export function formatIsoWeek(value: string) {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) {
    return value;
  }

  const day = date.getUTCDay() || 7;
  const thursday = new Date(date);
  thursday.setUTCDate(thursday.getUTCDate() + 4 - day);
  thursday.setUTCHours(0, 0, 0, 0);

  const weekYear = thursday.getUTCFullYear();
  const firstThursday = new Date(Date.UTC(weekYear, 0, 4));
  const firstThursdayDay = firstThursday.getUTCDay() || 7;
  firstThursday.setUTCDate(
    firstThursday.getUTCDate() + 4 - firstThursdayDay,
  );

  const week =
    1 + Math.round((thursday.getTime() - firstThursday.getTime()) / (7 * DAY));

  return `${weekYear} W${String(week).padStart(2, "0")}`;
}
